import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

export const GET_TAXONOMIES_BY_VERSION_QUERY_KEY = (version: string) => [
  'taxonomies',
  version,
];

export function useGetTaxonomiesByVersion(version: string) {
  const { data, isFetching } = useQuery({
    queryKey: GET_TAXONOMIES_BY_VERSION_QUERY_KEY(version),
    queryFn: () => TaxonomiesService.getTaxonomiesByVersion(version),
    enabled: !!version,
  });

  return {
    categories: data,
    isLoading: isFetching,
  };
}
